var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',{attrs:{"dense":""}},_vm._l((_vm.unitTypes),function(unitType,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.$emit('input', unitType)}}},[_c('v-list-item-title',[_vm._v(_vm._s(unitType))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }